import { CondicionPagoService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";
import { WarningException } from "utils";

export const CondicionPagoManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();
  const buscarPorId = (Id, esLookup) => {
    return CondicionPagoService.buscarPorId(Id, esLookup).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const listado = (where) => {
    return CondicionPagoService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crear = (condicionPago) => {
    return validar(condicionPago).then(() =>
      CondicionPagoService.crear(condicionPago).then((res) => {
        if (!res.Success) {
          handleException(res);
        }
        return res.Data;
      }));
  };

  const actualizar = (condicionPago) => {
    return validar(condicionPago).then(() =>
      CondicionPagoService.actualizar(condicionPago).then((res) => {
        if (!res.Success) {
          handleException(res);
        }
        return res.Data;
      }));
  };

  const exportar = (where) => {
    return CondicionPagoService.exportar(where).then((res) => {
      return res;
    });
  };

  const validar = (condicionPago) => {
    return new Promise((res) => res(condicionPago)).then((condicionPago) => {
      let requiredFields = [];

      if (!condicionPago.Descripcion) {
        requiredFields.push("Descripción");
      }

      if (condicionPago.Dias === undefined
        || condicionPago.Dias === null
        || condicionPago.Dias === ""
        || isNaN(Number(condicionPago.Dias))
        || condicionPago.Dias <= 0) {
        requiredFields.push("Dias");
      }

      if (requiredFields.length > 0) {
        throw new WarningException(
          `Los siguientes campos son requeridos: ${requiredFields.join(", ")}.`
        );
      }
    });
  };

  return {
    buscarPorId,
    listado,
    crear,
    actualizar,
    exportar,
  };
})();
